var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.mensagem)+" ")]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.textoBotao)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }